export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/1c51a79398276ba6cc677c7e60cd4bfb.png";